<template>
  <gg-card>
    <gg-card-header>
      Submit Reply
    </gg-card-header>
    <gg-card-text v-if="cancellation.replies_enabled">
      <gg-input-label>Message body</gg-input-label>
      <v-textarea
        dense
        class="gg-input"
        outlined
        v-model="model.message"
        v-validate="rules.message"
        data-vv-name="message"
        data-vv-as="Message"
        :error-messages="errors.collect('message')"
      ></v-textarea>
      <gg-btn
        color="primary"
        tile
        small
        :loading="loading"
        :disabled="loading"
        @click="submitReply"
      >
        Submit reply
      </gg-btn>
    </gg-card-text>
    <v-card-text v-else>
      You can no longer reply to this request.
    </v-card-text>
  </gg-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'Reply',

  data: () => ({
    loading: false,
    model: {
      message: '',
    },
    rules: {
      message: {
        required: true
      }
    }
  }),
  computed: {
    ...mapGetters(['cancellation'])
  },
  methods: {
    ...mapActions(['cancellationReply', 'reportSuccess', 'reportError']),
    clearData () {
      this.model.message = ''
    },
    updatePosts () {
      this.$emit('post-added')
    },
    async submitReply () {
      try {
        const valid = await this.$validator.validateAll()

        if (!valid) return

        this.loading = true

        const data = {
          cr_id: this.$route.params.id,
          message: this.model.message
        }

        const response = await this.cancellationReply(data)

        this.loading = false
        this.reportSuccess(response.resultmsg)
        this.clearData()
        this.updatePosts()
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
    }
  }
}
</script>
